<template>
  <div class="boon-input-container half">
    <input
      ref="input"
      :type="type"
      :readonly="readonly"
      :class="['boon-input', { 'boon-input-filled': !!value }]"
      :value="value"
      @change="updateValue"
      @blur="onBlur"
    />
    <label>{{ label }}</label>
    <span class="focus-border" />
  </div>
</template>
<script>
export default {
  name: 'inputField',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },

  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },

    updateValue(event) {
      this.$emit('input', event.target.value);
    },

    focus() {
      this.$refs['input'].focus();
    },
  },
};
</script>

<style scoped>
div {
  position: relative;
}

:focus {
  outline: none;
}

:disabled {
  cursor: not-allowed;
}

.boon-input-container {
  margin: 7px 14px;
  z-index: 1;
}

.boon-input {
  border: 0;
  padding: 7px 0;
  border-bottom: 1px solid #ccc;
  width: 100%;
  background-color: transparent;
  color: inherit;
}

.boon-input ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #1c2731;
  transition: 0.4s;
}

.boon-input:focus ~ .focus-border,
.boon-input-filled ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.boon-input ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.boon-input:focus ~ label,
.boon-input-filled ~ label {
  top: -16px;
  font-size: 12px;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/form/inputField.vue